module.exports = "/static/images/bct-divider.svg";